export default __webpack_public_path__ + "static/media/CT.a4fd0581.svg";